<template>
	<div id="app">
		<template v-if="$route.name !== '404'">
			<Header v-if="$store.getters.isPc" />
			<keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
			<router-view v-if="!$route.meta.keepAlive"></router-view>
			<Footer v-if="$store.getters.isPc" />
		</template>
		<template v-else>
			<router-view></router-view>
		</template>
	</div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
export default {
	components: { Header, Footer },
	beforeCreate() {
		this.$store.commit('SET_PLATFORM', /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent));
		if (this.$store.getters.isPc) document.documentElement.style.fontSize = '37.5px';
		else import('lib-flexible');
	}
};
</script>
<style lang="less">
.row {
	display: flex;
	flex-direction: row;
}
.col {
	display: flex;
	flex-direction: column;
}
.cb {
	align-items: center;
	justify-content: space-between;
}
.cc {
	align-items: center;
	justify-content: center;
}
</style>
